<template>
  <component :is="type" v-bind="linkProps(to)" @click="toPage()" class="lowest-menu">
    <slot />
    <div class="collection" :class="activeName == 'all' ?'active-all' :'active-collect'" @click.stop="collectMenu()"></div>
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate'
import { addMenuCollect, delMenuCollect } from "@/api/system/menu";

export default {
  props: {
    to: {
      type: [String, Object],
      required: true
    },
    activeName: {
      type: String,
      required: true,
    }
  },
  computed: {
    isExternal() {
      return isExternal(this.to)
    },
    type() {
      if (this.isExternal) {
        return 'a'
      }
      return 'div'
    }
  },
  methods: {
    linkProps(to) {
      if (this.isExternal) {
        return {
          href: to,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        to: to
      }
    },
    toPage() {
      let path = this.linkProps(this.to)
      let index = (window.location.href).search(this.to)
      if (index == -1) {
        this.$router.push(path.to)
      }
    },
    collectMenu() {
      let index = this.to.lastIndexOf('/')
      let path = this.to.slice(index + 1)
      if (this.activeName == "all") {
        addMenuCollect(path).then(res=> {
          if (res.code == 200) {
            this.$message.success(res.msg)
          }
        }).catch(err=> {
          console.log(err);
        })
      }
      if (this.activeName == "collect") {
        delMenuCollect(path).then(res=> {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.$emit('getMenuCollect')
          }
        }).catch(err=> {
          console.log(err);
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .lowest-menu {
    position: relative;
  }
  .lowest-menu:hover .collection {
    display: block;
  }
  .collection {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
    width: 17px;
    height: 16px;
    z-index: 100;
    display: none;
    cursor: pointer;
  }
  .active-all {
    background: url("../../../assets/images/star1.png") no-repeat;
    background-size: 100% 100%;
  }
  .active-collect {
    background: url("../../../assets/images/star.png") no-repeat;
    background-size: 100% 100%;
  }
  .collection img {
    width: 100%;
    height: 100%;
  }
</style>
